export const PRIORITY_STYLES = {
    low: "bg-sage-soft/60 text-warm-900",
    medium: "bg-mustard-soft/70 text-warm-900",
    high: "bg-terracotta text-cream",
};

// Tiny human-friendly short form for the ↻ recurrence chip — fits inside a
// pill next to the priority chip. Verbose copy lives in the QuickAddSheet
// helper text and in the chip's title= tooltip.
const DAY_SHORT = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];

export function recurrenceShort(rec) {
    if (!rec || !rec.type || rec.type === "none") return "";
    if (rec.type === "weekly") {
        const d = DAY_SHORT[rec.recurrence_day ?? rec.day ?? 0] || "mon";
        const i = rec.recurrence_interval ?? rec.interval ?? 1;
        return i > 1 ? `${i}w · ${d}` : `wk · ${d}`;
    }
    if (rec.type === "monthly") {
        const d = rec.recurrence_day ?? rec.day ?? 1;
        const i = rec.recurrence_interval ?? rec.interval ?? 1;
        return i > 1 ? `${i}mo · ${d}` : `mo · ${d}`;
    }
    if (rec.type === "yearly") {
        const m = rec.recurrence_month ?? rec.month ?? 1;
        const d = rec.recurrence_day ?? rec.day ?? 1;
        return `yr · ${m}/${d}`;
    }
    if (rec.type === "custom") {
        const u = rec.recurrence_unit || rec.unit || "day";
        const i = rec.recurrence_interval ?? rec.interval ?? 1;
        return `every ${i}${u[0]}`;
    }
    return "↻";
}
